import { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useForm } from 'react-hook-form';
import { AiOutlineSearch } from 'react-icons/ai';
import { RECAPTCHA_SITE_KEY, SHOW_COMMEMORATE } from 'src/constants';
import { convertObjPathNoneEncode } from 'src/utils/helper';
import styled from 'styled-components';
// import _ from 'lodash';
import { ErrorMessage } from '@hookform/error-message';
import { CgClose } from 'react-icons/cg';
import { FaSearch } from 'react-icons/fa';

const WidgetSearchFullPage = ({ searchInPage = false, toggle, handle }: any) => {
  const recaptchaRef = useRef<any>(null);
  const searchBoxRef = useRef<any>(null);

  // ---------- expand Search ----------
  const [recaptchaBox, setRecaptchaBox] = useState(false);
  const {
    register,
    formState: { errors },
    handleSubmit,
    watch
  } = useForm();
  const textSearch = watch('textSearch');

  const onSearch = () => {
    setRecaptchaBox(true);
  };

  const onReCAPTCHAChange = async (captchaCode: any) => {
    if (!captchaCode) return null;

    try {
      const response = await fetch('/api/recaptcha', {
        method: 'POST',
        body: JSON.stringify({ textSearch, captcha: captchaCode }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        setRecaptchaBox(false);
        const serachParams = convertObjPathNoneEncode({
          q: encodeURIComponent(textSearch || '')
        });

        window.location.href = await `/search${serachParams}`;
      } else {
        const error = await response.json();
        throw new Error(error.message);
      }
    } catch (err: any) {
      alert(err?.message || 'Something went wrong');
      setRecaptchaBox(false);
    } finally {
      recaptchaRef.current = null;
      setRecaptchaBox(false);
    }
  };
  // console.log(onReCAPTCHAChange);
  return (
    <>
      {!searchInPage ? (
        <>
          <SearchBox>
            <div className={`slide-search ${toggle ? 'fadein' : 'fadeout'}`} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
              <button id='close-search' onClick={() => handle()} aria-label='Search Close'>
                <CgClose />
              </button>
              {recaptchaBox && (
                <BoxRecaptcha>
                  <ReCAPTCHA ref={recaptchaRef} sitekey={RECAPTCHA_SITE_KEY} onChange={onReCAPTCHAChange} />
                </BoxRecaptcha>
              )}
              <form onSubmit={handleSubmit(onSearch)} className='search-box-full' ref={searchBoxRef}>
                <input type='text' {...register('textSearch')} required placeholder='ค้นหา ...' className='text-search' />
                <ButtonSearch type='submit' aria-label='Search Submit'>
                  <FaSearch />
                </ButtonSearch>
              </form>
            </div>
          </SearchBox>
        </>
      ) : (
        <>
          {recaptchaBox && (
            <BoxRecaptcha position='fixed' positionTop recaptchaDesktop>
              <ReCAPTCHA ref={recaptchaRef} sitekey={RECAPTCHA_SITE_KEY} onChange={onReCAPTCHAChange} />
            </BoxRecaptcha>
          )}
          <SearchBoxDesktopInpageSearch>
            <form onSubmit={handleSubmit(onSearch)} className='btn-search' ref={searchBoxRef}>
              <input
                {...register('textSearch', {
                  required: 'โปรดกรอกข้อมูลที่ต้องการค้นหา...'
                })}
                className='search-in-page text-search'
                type='text'
                placeholder='ค้นหา ...'
              />
              <button type='submit' aria-label='Search Submit'>
                <AiOutlineSearch />
              </button>
            </form>
            <p className='error-search-in-page'>
              <ErrorMessage errors={errors} name='textSearch' />
            </p>
          </SearchBoxDesktopInpageSearch>
        </>
      )}
    </>
  );
};

const SearchBoxDesktopInpageSearch = styled.div`
  form {
    position: relative;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #00000071;
    &:before {
      content: '';
      position: absolute;
      left: 0px;
      width: 150px;
      height: 1px;
      bottom: -1px;
      background: #ed1a3b;
    }
    .text-search {
      cursor: text;
      text-rendering: optimizeLegibility !important;
      /* user-select: none; */
      transition: all 0.5s;
      background-color: transparent;
      vertical-align: middle;
      position: relative;
      outline: 0;
      height: 36px;
      line-height: 30px;
      margin: 0;
      padding: 0 0;
      font-size: 18px;
      font-weight: 500;
      color: #7f7f7f;
      border: none;
      box-sizing: border-box;
      transition: border-color 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9), width 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9);
    }
    button {
      cursor: pointer;
      border: unset;
      background-color: unset;
      padding: 0;
    }
    svg {
      vertical-align: middle;
      font-size: 16px;
    }
  }
  .search-in-page {
    width: 100%;
  }
  .error-search-in-page {
    margin-top: 5px;
    color: red;
    font-size: 12px;
  }
`;

// const SearchBoxDesktop = styled.div`
//   display: table-cell;
//   vertical-align: middle;
//   button {
//     cursor: pointer;
//     border: unset;
//     background-color: unset;
//     padding: 0;
//   }
//   svg {
//     vertical-align: middle;
//     font-size: 16px;
//   }
//   .p-20 {
//     padding: 0 20px !important;
//   }
//   .text-search {
//     cursor: text;
//     text-rendering: optimizeLegibility !important;
//     /* user-select: none; */
//     transition: all 0.5s;
//     background-color: transparent;
//     vertical-align: middle;
//     position: relative;
//     outline: 0;
//     width: 0;
//     height: 30px;
//     line-height: 30px;
//     margin: 0;
//     padding: 0 0;
//     font-size: 16px;
//     font-weight: 500;
//     color: #7f7f7f;
//     border: none;
//     box-sizing: border-box;
//     transition: border-color 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9),
//       width 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9);
//   }
//   .search-active {
//     width: 148px;
//     border-left: 1px solid #d1d1d1;
//   }
// `;
const BoxRecaptcha: any = styled.div<{
  position: string | any;
  positionTop: string | any;
  recaptchaDesktop: string | any;
}>`
  position: ${({ position }) => position || 'relative'};
  top: ${({ positionTop }) => (positionTop ? '0' : 'auto')};
  width: ${({ recaptchaDesktop }) => recaptchaDesktop && '100%'};
  height: ${({ recaptchaDesktop }) => (recaptchaDesktop ? '100vh' : '100%')};
  background-color: rgb(0, 0, 0, 0.5) !important;
  z-index: 99;
  right: 0;
  iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const ButtonSearch = styled.button`
  display: flex;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  vertical-align: middle;
  border-bottom: 2px solid ${({ color }) => color || '#ed1a3b'};
  border-radius: 0px;

  &:focus {
    outline: none;
  }
`;

const SearchBox = styled.div`
  position: absolute;
  display: contents;
  .slide-search {
    overflow: hidden;
    position: fixed;
    padding: 0px;
    background-color: rgb(0, 0, 0, 0.9);
    z-index: 999;
    top: 0px;
    width: 100%;
    height: 100vh;
    right: -101%;
    transition: ease-in-out 400ms;

    button {
      border: none;
      font-size: 30px;
      position: absolute;
      top: 0;
      right: 0%;
      width: 80px;
      height: 80px;
      z-index: 25;
      background: none;
      color: #ed1a3b !important;

      &:focus {
        outline: 0;
      }
    }

    &.fadein {
      right: 0;
    }

    &.fadeout {
    }

    .search-box-full {
      width: 100%;
      max-width: 600px;
      margin: auto 0;
      position: absolute;
      top: 35%;
      left: 48%;
      transform: translate(-50%, 50%);

      input {
        caret-color: red;
        display: block;
        text-align: start;
        width: 100%;
        margin: 5px auto;
        padding: 10px 0 10px 15px;
        /* background-color: transparent !important; */
        background: none;
        border: none;
        color: #ed1a3b !important;
        border-bottom: 1px solid #ed1a3b !important;
        box-shadow: #ed1a3b 0px 10px 10px -10px;

        font-size: 32px !important;
        font-weight: 400;
        border-radius: 0px;

        &:focus {
          outline: none;
        }

        &::placeholder {
          color: #ed1a3b !important;
          background-color: transparent !important;
        }
      }

      button {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        position: absolute;
        margin-top: 0px;
        right: 0;
        top: 15px;
        font-size: 24px;
        border: none;
        /* width: 100%; */
        height: 55px;
        color: #ed1a3b !important;
        background: none;

        &:focus {
          outline: none;
        }

        &:hover {
          svg {
            filter: drop-shadow(1px 2px 2px #ed1a3b);
          }
          background: transparent !important;
        }
      }
    }

    @media (max-width: 768px) {
      .search-box-full {
        width: 80%;
        left: 50%;
      }
    }

    @media (max-width: 480px) {
      .search-box-full {
        position: relative;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        input {
          width: 100%;
        }
      }
    }
  }
`;

export default WidgetSearchFullPage;
